import {HttpStatusCode} from '../../Constants'
import {Nullable} from '../../../app/TypeHelpers'
import {ErrorResponseBody} from '../../response/ErrorResponseBody'
import EventEmitterEx from '../../../components/shared/pageBaseComponents/EventEmitterEx'
import {RequestItemError} from '../../response/RequestItemError'

export class BaseHttpError extends Error {
    constructor(
        readonly name: string,
        readonly status: HttpStatusCode,
        readonly responseBody: Nullable<ErrorResponseBody>,
    ) {
        super()
    }

    async broadcast(eventEmitter: EventEmitterEx, includeItemError: boolean = false): Promise<void> {
        await eventEmitter.showHeadingAreaMessage(this, includeItemError)

        if (!this.responseBody) {
            return
        }

        this.responseBody.requestItemErrors.forEach((item) => {
            this.broadcastFieldErrors(eventEmitter, item)
            eventEmitter.emit(item.resultCode, item)
        })
    }

    private broadcastFieldErrors(eventEmitter: EventEmitterEx, item: RequestItemError): void {
        if (!item.fields) {
            return
        }

        item.fields.forEach((field) => {
            eventEmitter.emit(field, item)
        })
    }
}
